import { NotFound } from "@dgs/core";
import { FC } from "react";
import { Route, Routes } from "react-router";
import { IntegrationDetailPage } from "./IntegrationDetailPage";
import { IntegrationList } from "./IntegrationList";

export const IntegrationPage: FC = () => {
	return (
		<Routes>
			<Route index element={<IntegrationList />} />
			<Route path=":id" element={<IntegrationDetailPage />} />
			<Route path="*" element={<NotFound />} />
		</Routes>
	);
};
